import React from 'react';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isSearchResult?: boolean;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = React.memo(({
  currentPage,
  totalPages,
  onPageChange,
  isSearchResult = false,
  className = ""
}) => {
  const { t } = useTranslation();

  // Don't render pagination if there's no pages
  if (!totalPages || totalPages <= 1) {
    return null;
  }

  const handlePrevious = () => {
    onPageChange(Math.max(currentPage - 1, 1));
  };

  const handleNext = () => {
    onPageChange(Math.min(currentPage + 1, totalPages));
  };

  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  return (
    <>
      {totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            float: "right",
          }}
          className="mobile-float-none"
        >
          {(isSearchResult ? totalPages <= 10 : true) && (
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                {/* Previous Button */}
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""
                    }`}
                >
                  <a
                    className="page-link"
                    onClick={handlePrevious}
                  >
                    {t("userProfile.previous")} 
                  </a>
                </li>

                {/* Page Numbers */}
                {Array.from({ length: totalPages }).map((_, index) => (
                  <li
                    className={`page-item ${currentPage === index + 1 ? "active" : ""
                      }`}
                    key={index}
                  >
                    <a
                      className="page-link"
                      onClick={() => handlePageClick(index + 1)}
                    >
                      {index + 1}
                    </a>
                  </li>
                ))}

                {/* Next Button */}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <a
                    className="page-link"
                    onClick={handleNext}
                  >
                    {t("userProfile.next")}
                  </a>
                </li>
              </ul>
            </nav>
          )}
        </div>
      )}
    </>
  );
});

Pagination.displayName = 'Pagination';

export default Pagination;